// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2025 
//import vectorTile from 'ol/source/VectorTile';
import { appendParameters } from '../../Core/Utils';
import {IAjax} from '../../../../../CommonScripts/Abstractions';

class GeognoSISVector extends ol.source.Vector {
    constructor(options) {
        super(options);
        this.sessionId = options.sessionId;
        this.overlay = options.overlay;
        this.ajaxWrapper = options.ajaxWrapper;
        this.setLoader(this.loaderFunction.bind(this));
    }
    loaderFunction(extent, resolution, projection) {
        var vectorUrl = this.overlay.getVectorUrl();
        var params = {
            'CRS': projection.getCode(),
            'bbox': extent.join(','),
            'uniqueParam': performance.now(),
            start: 0,
            noFeaturesToGet:200
        };
        var me = this;
        this.getFeatures(vectorUrl, params, projection);

        /*vectorUrl = appendParameters(vectorUrl, params);
        var wrapper = this.ajaxWrapper;
        var me = this;
        var layerProj = ol.proj.get('EPSG:' + this.overlay.epsgCode);
        wrapper.get(vectorUrl).
            then(function (response) {
                var format = me.getFormat();
                var features = format.readFeatures(response.data, { dataProjection: layerProj.getCode(), featureProjection: projection.getCode() });
                if (features && features.length > 0) {
                    me.addFeatures(features);
                }
            });*/

    }

    getFeatures(baseUrl, params, projection) {
        var me = this;
        var wrapper = this.ajaxWrapper;
        var vectorUrl = appendParameters(baseUrl, params);
        return wrapper.get(vectorUrl)
            .then(function (response) {
                var format = me.getFormat();
                var layerProj = ol.proj.get('EPSG:' + me.overlay.epsgCode);
                var features = format.readFeatures(response.data,
                    { dataProjection: layerProj.getCode(), featureProjection: projection.getCode() });
                if (features && features.length > 0) {
                    me.addFeatures(features);
                }
                if (response.data.links) {
                    var links = response.data.links;
                    links = me.flattenLinks(links);
                    var nextLink = me.getLink(links, 'next');
                    if (nextLink) {
                        var newParams = {
                            'CRS': params.CRS,
                            'bbox': params.bbox,
                            'uniqueParam': performance.now(),
                            start: params.start + params.noFeaturesToGet,
                            noFeaturesToGet: params.noFeaturesToGet
                        };
                        me.getFeatures(baseUrl, newParams, projection);
                    }
                } 
            })
            .catch(function(err) {
                console.log('error getting features: ' + err);
            });
    }

    flattenLinks(links) {
        var newLinks = null;
        if (links && links.length > 0) {
            newLinks = [];
            for (var c = 0; c < links.length; c++) {
                var link = links[c];
                if (Array.isArray(link)) {
                    newLinks.push(...this.flattenLinks(link));
                } 
                else {
                    newLinks.push(link);
                }
            }
        }
        return newLinks;
    }
    getLink(links, rel) {
        var link = null;
        if (links && Array.isArray(links)) {
            var found = links.filter((element) => {
                return element.rel === rel;
            });
            if (found.length > 0)
                link = found[0];
        }
        return link;
    }
}

export default GeognoSISVector;

